// extracted by mini-css-extract-plugin
export default {"paperWrapper":"Paper_paperWrapper__QlkHR"};